// Внешние (системные) браузерные уведомления — работают, даже если вкладка свёрнута
// или диспетчер переключился на другое окно. Требуют разрешения пользователя один раз.
export function requestNotificationPermission() {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
}

export function showBrowserNotification(title: string, body: string) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  // Если вкладка и так открыта и видна — системное уведомление не нужно, оно и так на экране
  if (document.visibilityState === 'visible') return;
  try {
    new Notification(title, { body, icon: '/favicon.svg' });
  } catch {
    // некоторые окружения (например, без разрешений ОС) молча не показывают — не критично
  }
}
